import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../../services/apiConfig';
import { getAccessToken } from '../../services/accessToken';

// Create the API slice with auth headers
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers) => {
      const token = await getAccessToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      } else {
        headers.delete('Authorization');
      }
      return headers;
    },
  }),
  tagTypes: ['Employee', 'Department', 'TimeOff', 'Profile', 'Floorplan', 'FloorplanRoster', 'FloorplanActivity'],
  endpoints: () => ({}),
});
